import sortBy from 'lodash/sortBy';

import { FillInBlanksSentence } from '../fill-in-blanks.constants';

export function sortFillInBlanksSentences(sentences: FillInBlanksSentence[]) {
  return sortBy(sentences, 'sort');
}
